import type { Device } from '@api/hooks/useDevices';
import { useRemoveDevice } from '@api/hooks/useDevices';
import { Button, CardItemInner, Chip } from '@gurupay/gp-ui-library';
import { formatUtcDate } from '@utils/utils';
import { useTranslation } from 'react-i18next';

interface DeviceItemProps {
	device: Device;
}

const labelMapper: Record<'ios' | 'android', string> = {
	ios: 'iOS',
	android: 'Android',
};

export const DeviceItem = ({ device }: DeviceItemProps) => {
	const { t } = useTranslation('', { keyPrefix: 'pushNotifications' });
	const { mutate: removeDevice, isPending } = useRemoveDevice();

	const platformLabel: string | undefined =
		device.platform && labelMapper[device.platform];
	const appVersion = device.app_version ? `v${device.app_version}` : undefined;
	const handleRemove = () => removeDevice(device.id);

	return (
		<CardItemInner
			actions={
				<Button disabled={isPending} onClick={handleRemove} size="sm" variant="outlined">
					{t('remove')}
				</Button>
			}
			title={
				<div className="flex gap-space-8">
					{device.device_name ?? ''}
					{!!platformLabel && (
						<Chip color="success" label={platformLabel} size="small" variant="filled" />
					)}
					{!!appVersion && (
						<Chip color="primary" label={appVersion} size="small" variant="outlined" />
					)}
				</div>
			}
		>
			{t('lastRegistered', { date: formatUtcDate(device.last_registered_at) })}
		</CardItemInner>
	);
};
